import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Popper } from '@mui/material';
import { FindLoad, FindSuccessItem, Images } from 'utils';
import { CloseButton, MinLoader } from 'components';
import { httpRequestsOnSuccessActions, taskActions } from 'store';
import { taskStatusEnums } from '../constants';

const ACTION_TYPE = 'UPDATE_TASK';
export const TaskStatusBox = ({ info, requestParams, disabled }) => {
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = useState(null);
    const openStatus = Boolean(anchorEl);
    const id = openStatus ? 'simple-popper' : undefined;
    const [selected, setSelected] = useState('');
    const loader = FindLoad(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);

    useEffect(() => {
        if(success){
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            setSelected('');
        }
    }, [success]);
    const handleClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (disabled) return;
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const renderColorAndText = (status) => {
        switch (status) {
            case taskStatusEnums.PENDING:
                return {
                    filter: 'brightness(0) saturate(100%) invert(49%) sepia(8%) saturate(444%) hue-rotate(182deg) brightness(92%) contrast(87%)',
                    backgroundColor: '#F5F5F5',
                    circleColor: '#717680',
                    color: '#414651',
                    text: 'Pending',
                    value: taskStatusEnums.PENDING,
                };
            case taskStatusEnums.ASSIGNED:
                return {
                    filter: 'brightness(0) saturate(100%) invert(40%) sepia(7%) saturate(4391%) hue-rotate(194deg) brightness(89%) contrast(93%)',
                    backgroundColor: '#EFF8FF',
                    circleColor: '#4E5BA6',
                    color: '#363F72',
                    text: 'Assigned',
                    value: taskStatusEnums.ASSIGNED,
                };
            case taskStatusEnums.IN_PROGRESS:
                return {
                    filter: 'brightness(0) saturate(100%) invert(33%) sepia(95%) saturate(1584%) hue-rotate(210deg) brightness(97%) contrast(90%)',
                    backgroundColor: '#EFF8FF',
                    circleColor: '#1570EF',
                    color: '#1570EF',
                    text: 'In Progress',
                    value: taskStatusEnums.IN_PROGRESS,
                };
            case taskStatusEnums.COMPLETED:
                return {
                    filter: 'brightness(0) saturate(100%) invert(34%) sepia(82%) saturate(946%) hue-rotate(117deg) brightness(91%) contrast(98%)',
                    backgroundColor: '#ECFDF3',
                    circleColor: '#027A48',
                    color: '#027A48',
                    text: 'Completed',
                    value: taskStatusEnums.COMPLETED,
                };
            case taskStatusEnums.CANCELLED:
                return {
                    filter: 'brightness(0) saturate(100%) invert(31%) sepia(51%) saturate(3011%) hue-rotate(343deg) brightness(100%) contrast(89%)',
                    backgroundColor: '#FEF3F2',
                    circleColor: '#B42318',
                    color: '#B42318',
                    text: 'Cancelled',
                    value: taskStatusEnums.CANCELLED,
                };
            default:
                return { backgroundColor: '', circleColor: '', color: '', text: '' };
        }
    };

    const { filter, backgroundColor, circleColor, color, text } = renderColorAndText(info?.status);

    const statuses = [
        { ...renderColorAndText(taskStatusEnums.PENDING) },
        { ...renderColorAndText(taskStatusEnums.ASSIGNED) },
        { ...renderColorAndText(taskStatusEnums.IN_PROGRESS) },
        { ...renderColorAndText(taskStatusEnums.COMPLETED) },
        { ...renderColorAndText(taskStatusEnums.CANCELLED) },
    ];

    const handleChangeStatus = (type) => {
        setAnchorEl(null);
        setSelected(info);
        dispatch(taskActions.updateTask(info?.id, { status: type?.value }, requestParams));
    };

    return (
        <div>
            <div className="flex-align-center" style={{ gap: 8 }}>
                <button
                    aria-describedby={id}
                    onClick={handleClick}
                    className="status-card-box"
                    style={{ backgroundColor: backgroundColor, border: 'none', height: 28, cursor: disabled ? 'default' : 'pointer' }}
                >
                    {text && <div style={{ backgroundColor: circleColor }} />}
                    <p style={{ color: color }}>{text ? text : '--'}</p>
                    {selected?.id === info?.id && loader?.length ? (
                        <MinLoader height={18} width={18} color={circleColor} margin={'0'} position={'relative'} />
                    ) : (
                        !disabled && <img style={{ filter: filter }} src={Images.dropdownArrow} alt="" />
                    )}
                </button>
            </div>

            <Popper
                id={id}
                open={openStatus}
                anchorEl={anchorEl}
                className="status-popper-box"
                placement="bottom-start"
                style={{ position: 'absolute', zIndex: 1500 }}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
            >
                <div>
                    <div className="status-popper-header">
                        <p>Update Status</p>
                        <CloseButton handleCLic={handleClick} />
                    </div>
                    <div className="status-popper-body">
                        {statuses?.map((i, j) => (
                            <button
                                key={j}
                                onClick={() => handleChangeStatus(i)}
                                className="status-card-box"
                                style={{ backgroundColor: 'transparent', border: 'none' }}
                            >
                                <div style={{ backgroundColor: i?.circleColor }} />
                                <p style={{ color: i?.color }}>{i?.text}</p>
                            </button>
                        ))}
                    </div>
                </div>
            </Popper>
            {openStatus && (
                <div
                    className="beck-drop"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setAnchorEl(null);
                    }}
                />
            )}
        </div>
    );
};
